<template>
	<div id="songs-switcher" @click="onClick" :class="{ 'side-opened': sideOpened }">
		<div class="title">{{ title }}</div>
		<IconChevronDown class="icon" />
	</div>
</template>

<script>
	import IconChevronDown from "@/components/icons/IconChevronDown";
	import { mapState } from "vuex";

	export default {
		components: {
			IconChevronDown
		},
		computed: {
			...mapState([
				"externalSearchOpened",
				"songsFilter",
				"rootSideOpened",
				"playlists",
				"authors",
				"sideOpened"
			]),
			title() {
				if (this.externalSearchOpened) {
					return this.$t("side.addSong");
				} else if (this.songsFilter.playlist !== null) {
					return this.playlists[this.songsFilter.playlist].title;
				} else if (this.songsFilter.author !== null) {
					return this.authors[this.songsFilter.author].title;
				} else if (this.songsFilter.onlyQueue) {
					return this.$t("side.queueSongs");
				} else if (!this.songsFilter.onlyQueue) {
					return this.$t("side.allSongs");
				}

				return "";
			}
		},
		methods: {
			onClick() {
				this.$store.commit("setRootSideOpened", !this.rootSideOpened);
			}
		}
	}

</script>

<style lang="scss" scoped>
	#songs-switcher {
		position: fixed;
		color: rgba(0, 0, 0, 0.97);
		height: 50px;
		width: 260px;
		left: -260px;
		background: rgb(233,196,106); /* Old browsers */
		background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
		cursor: pointer;
		top: 0;
		top: calc(constant(safe-area-inset-top) + 0px);
		top: calc(env(safe-area-inset-top) + 0px);

		-webkit-transition: left 0.2s;
		-moz-transition: left 0.2s;
		-o-transition: left 0.2s;
		transition: left 0.2s;

		&.side-opened {
			left: 0;
		}

		&.opened {
			.icon-menu {
				transform: rotate(180deg);
				transform-origin: center center;
				margin-top: 6px;
			}

			.title {
				opacity: 0;
			}
		}

		&:hover {
			background: rgba(244,162,97,1);
		}

		div.title {
			padding: 15px 15px 0 15px;
			float: left;
			-webkit-transition: opacity 0.2s;
			-moz-transition: opacity 0.2s;
			-o-transition: opacity 0.2s;
			transition: opacity 0.2s;
		}

		div.icon-menu {
			margin: 10px 20px 0 0;
			float: right;

			-webkit-transition: transform 0.2s, margin 0.2s;
			-moz-transition: transform 0.2s, margin 0.2s;
			-o-transition: transform 0.2s, margin 0.2s;
			transition: transform 0.2s, margin 0.2s;
		}

	}
</style>
